/* ELORA CARE — elora-chat-bento: topic pills swap the thread, messages fade in
   one after another. Ported from docs/mock.js ("chat"). The threads are rendered
   server-side, so the copy is in the DOM with JavaScript switched off too. */
window.Elora = window.Elora || {};

(function () {
  var NS = window.Elora;

  function build(root) {
    var pillBox = root.querySelector('[data-pills]');
    var threadBox = root.querySelector('[data-threads]');
    if (!threadBox) return;

    var threads = Array.prototype.slice.call(threadBox.querySelectorAll('[data-chat-thread]'));
    if (!threads.length) return;
    var timers = [];

    function stagger(thread) {
      timers.forEach(clearTimeout);
      timers = [];
      var msgs = thread.querySelectorAll('.msg');
      for (var i = 0; i < msgs.length; i++) {
        (function (m, idx) {
          m.classList.remove('in');
          timers.push(setTimeout(function () { m.classList.add('in'); }, 40 + idx * 180));
        })(msgs[i], i);
      }
    }

    function show(key) {
      for (var i = 0; i < threads.length; i++) {
        var on = threads[i].dataset.chatThread === String(key);
        threads[i].hidden = !on;
        if (on) stagger(threads[i]);
      }
    }

    if (pillBox) {
      pillBox.addEventListener('click', function (e) {
        var btn = e.target.closest('.gpill');
        if (!btn) return;
        var pills = pillBox.querySelectorAll('.gpill');
        for (var i = 0; i < pills.length; i++) {
          var on = pills[i] === btn;
          pills[i].classList.toggle('is-on', on);
          pills[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        show(btn.dataset.topic);
      });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      var msgs = threadBox.querySelectorAll('.msg');
      for (var i = 0; i < msgs.length; i++) msgs[i].classList.add('in');
      return;
    }

    var started = false;
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting && !started) {
        started = true;
        stagger(threads[0]);
        io.disconnect();
      }
    }, { threshold: 0.25 });
    io.observe(threadBox);
  }

  NS.initChatBento = function (scope) {
    var roots = (scope || document).querySelectorAll('[data-elora-chat]');
    for (var r = 0; r < roots.length; r++) {
      if (roots[r].dataset.eloraChatReady === '1') continue;
      roots[r].dataset.eloraChatReady = '1';
      build(roots[r]);
    }
  };

  function boot() { NS.initChatBento(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    NS.initChatBento(e.target || document);
  });
})();
